<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h2>Message architecture</h2>
      </v-col>
      <v-col cols="12">
        <v-btn :to="`/users/project/${$route.params.id}/architecture/create`" light color="amber" class="mt-5 mb-5">Add
          Audience</v-btn></v-col>
      <v-col cols="4" v-for="item in items" :key="item.id">
        <v-card light height="100%">
          <v-card-title>
            <h3 class="title" v-if="item.doc.title">{{ item.doc.title }}</h3>
            <h3 class="title" v-else>{{ item.id }}</h3>
          </v-card-title>
          <v-card-text>
            <v-select v-if="doc && webrole === 'admin'" label="Assign a user" :items="doc.users"
              @change="updateDoc($event, item.id)" item-text="email" item-value="uid" v-model="item.assignedUser" />
            <v-chip small v-if="item.assignedUser" :close="webrole === 'admin'"
              @click:close="removeAssignedUser(item.id)">{{
                getUserEmail(item.assignedUser) }}</v-chip>
            <v-chip small v-else>No user assigned</v-chip>
          </v-card-text>
          <v-card-actions>
            <div class="d-flex flex-row justify-space-between w-100">
              <div class="d-flex gap-1">
                <v-btn :disabled="isDisabledButton(item)" light color="amber" class="mb-2"
                  @click="editCard(item.id)">Edit</v-btn>

                <v-btn light color="black" class="mb-2" @click="editCard(item.id)" outlined>View</v-btn>
              </div>
              <v-btn v-if="webrole === 'admin'" light color="black" class="mb-2" outlined
                @click="deleteRequest(item.id)">Delete</v-btn>
            </div>

          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <bottom-navigation :save="false" :next="false" :prev="false" :list="`architecture`" :gridView="false"
      :gridToggle="false">
    </bottom-navigation>

    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline">Are you sure you want to delete this?</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="deleteItem">
            Delete
          </v-btn>
          <v-btn color="amber" text @click="closeDialog">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import firebase from "firebase";
const fb = require("@/firebaseConfig.js");
import { BottomNavigation } from "@/components/core";
import router from "@/router";

export default {
  name: "UserArchitectureMenu",
  data() {
    return {
      items: [],
      cardId: null,
      dialog: false,
      doc: null,
      collection: fb.architectureExCollection,
      returnRoute: "UserArchitectureMenu",
      webrole: null,
    };
  },
  components: {
    BottomNavigation,
  },
  computed: {
    ...mapState([
      "currentUser",
    ]),

  },
  mounted() {
    this.init();
    this.getProject();
    this.getUserRole();
  },
  methods: {
    getUserRole() {
      fb.profilesCollection
        .where("uid", "==", this.currentUser.uid)
        .get()
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
            this.webrole = querySnapshot.docs[0].data().webrole
          }
        })
    },
    init() {
      fb.architectureExCollection
        .where("pid", "==", this.$route.params.id)
        .onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          this.items = items;
        });
    },
    isDisabledButton(item) {
      if (!item.assignedUser) return false
      if (item.assignedUser === this.currentUser.uid) return false
      if (this.webrole === 'admin') return false
      return true
    },
    getProject() {
      const id = this.$route.params.id
      if (id) {
        console.log("get project 2");
        let ref = fb.projectsCollection.where("id", "==", id);
        ref.onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((docs) => {
            let doc = docs.data();
            console.log('doc', doc)
            items.push(doc);
          });
          this.doc = items[0];
        })
      }
    },
    closeDialog() {
      this.cardId = null;
      this.dialog = false;
    },
    deleteRequest(id) {
      this.cardId = id;
      this.dialog = true;
    },
    deleteItem() {
      this.collection
        .doc(this.cardId)
        .delete()
        .then(() => {
          this.dialog = false;
          this.cardId = null;
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
    updateDoc($ev, id) {
      const userId = $ev
      const docId = id
      fb.architectureExCollection.doc(docId).update({
        assignedUser: userId,
      })
    },
    editCard(id) {
      this.$router.push(
        `/users/project/${this.$route.params.id}/architecture/${id}`
      );
    },
    removeAssignedUser(id) {
      fb.architectureExCollection.doc(id).update({
        assignedUser: firebase.firestore.FieldValue.delete(),
      })
    },
    getUserEmail(uid) {
      if (!this.doc || !this.doc.users) return uid
      const user = this.doc.users.find((u) => u.uid === uid)
      return user ? user.email : uid
    },
    change(id) {
      console.log('id', id)
    }
  },
};
</script>

<style lang="scss">
.w-100 {
  width: 100%;
}

.gap-1 {
  gap: .5rem;
}
</style>
